export function IsJsonString (str) {
  try {
    var MyJSON = JSON.stringify(str)
    var json = JSON.parse(MyJSON)
    if (json) {}
    if (typeof (str) === 'string') {
      if (str.length === 0) { return false }
    }
  } catch (e) {
    return false
  }
  return true
}
